module.exports = __webpack_public_path__ + "img/Logo_for_register@3x.b89f9f04.png";